(function () {
  'use strict';
  if (window.sdProductEnquiryLoaded) return;
  window.sdProductEnquiryLoaded = true;
  function emit(name, detail) {
    if (window.SDGrowth) window.SDGrowth.publish(name, detail);
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-sd-quote-link]');
    if (!link) return;
    var url = new URL(link.href, location.origin);
    var current = new URL(location.href);
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (key) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key).slice(0, 150));
    });
    url.searchParams.set('source', location.pathname);
    link.href = url.toString();
    if (url.searchParams.get('intent') === 'installation') emit('sd_installation_quote_start', { product_handle: url.searchParams.get('product') });
  });
  function init() {
    var params = new URLSearchParams(location.search);
    var handle = params.get('product') || '';
    var installation = params.get('intent') === 'installation';
    document.querySelectorAll('form[data-sdx-contact]').forEach(function (form) {
      function field(name) { return form.querySelector('[name="contact[' + name + ']"]'); }
      function set(name, value) { var input = field(name); if (input) input.value = value; }
      if (installation) {
        set('Request type', 'Installation planning');
        set('Request intent', 'installation_quote');
        set('tags', 'SD100X,installation_quote');
        var zip = field('Project ZIP');
        if (zip) {
          zip.required = true;
          var zipLabel = form.querySelector('label[for="' + zip.id + '"]');
          if (zipLabel) zipLabel.textContent = 'Project ZIP code *';
        }
        var formTitle = form.closest('.sdx-form-wrap').querySelector('.sdx-form-wrap__header h2');
        if (formTitle) formTitle.textContent = 'Request an installation quote';
        var formIntro = form.closest('.sdx-form-wrap').querySelector('.sdx-form-wrap__header p');
        if (formIntro) formIntro.textContent = 'Tell us where the product will go, your timeline and what you want included. We will review the scope before confirming service availability.';
        ['Project stage', 'Request type'].forEach(function (name) {
          var input = field(name);
          if (input) input.closest('.sdx-field').hidden = true;
        });
        var quoteFields = form.querySelector('[data-sd-qualification]');
        if (quoteFields) {
          quoteFields.hidden = false;
          quoteFields.querySelectorAll('select').forEach(function (input) { input.disabled = false; input.required = true; });
        }
      }
      var source = params.get('source') || '';
      if (/^\/products\/[a-z0-9-]+$/.test(source)) set('Source page', location.origin + source);
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (key) { set(key, (params.get(key) || '').slice(0, 150)); });
      if (form.querySelector('[data-sd-form-success]')) {
        var pending = null;
        try { pending = JSON.parse(sessionStorage.getItem('sd_pending_enquiry')); sessionStorage.removeItem('sd_pending_enquiry'); } catch (_) {}
        if (pending) emit('sd_enquiry_accepted', pending);
      }
      form.addEventListener('submit', function () {
        if (!form.checkValidity()) return;
        var honeypot = form.querySelector('[data-sdx-honeypot]');
        if (honeypot && honeypot.value) return;
        var details = { product_handle: handle, request_type: installation ? 'installation_quote' : 'support' };
        try { if (window.SDGrowth && window.SDGrowth.analyticsAllowed()) sessionStorage.setItem('sd_pending_enquiry', JSON.stringify(details)); } catch (_) {}
        emit('sd_enquiry_submit', details);
      });
      if (!/^[a-z0-9][a-z0-9-]{0,150}$/.test(handle)) return;
      var context = form.querySelector('[data-sd-enquiry-context]');
      if (context) { context.hidden = false; context.textContent = 'Loading the selected product...'; }
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(function (product) {
          var variant = product.variants.find(function (v) { return String(v.id) === params.get('variant'); }) || product.variants[0];
          var modelField = field('Product model or SKU');
          if (modelField && !modelField.value) modelField.value = (product.title + (variant.sku ? ' (' + variant.sku + ')' : '')).slice(0, 120);
          set('Selected product ID', String(product.id));
          set('Selected variant ID', String(variant.id));
          set('Page context', location.origin + '/products/' + handle);
          if (!source) set('Source page', location.origin + '/products/' + handle);
          if (context) context.textContent = (installation ? 'Installation quote: ' : 'Your selected product: ') + product.title + '. We will review your location and scope before confirming availability.';
        }).catch(function () {
          if (context) context.textContent = 'Please enter the product model below so we can match your enquiry to the right item.';
        });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
